var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComputerCharts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.88989 8.28009L8.88989 89.3101C8.88989 92.5023 11.4777 95.0901 14.6699 95.0901L133.94 95.0901C137.132 95.0901 139.72 92.5023 139.72 89.3101V8.28009C139.72 5.08788 137.132 2.50009 133.94 2.50009L14.6699 2.50009C11.4777 2.50009 8.88989 5.08788 8.88989 8.28009Z",
    fill: "#E9AF34",
    stroke: "#E9AF34",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M147.41 134C147.41 141.46 144.79 147.51 138.29 147.51C131.79 147.51 129.17 141.46 129.17 134C129.17 126.54 130.51 120.5 138.29 120.5C146.07 120.5 147.41 126.54 147.41 134Z",
    fill: "#DB6C2F",
    stroke: "#DB6C2F",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0599 23.6799C46.325 23.6799 41.6964 25.084 37.7595 27.7145C33.8226 30.3451 30.7542 34.084 28.9422 38.4585C27.1302 42.833 26.6562 47.6465 27.5799 52.2904C28.5036 56.9343 30.7837 61.2 34.1317 64.5481C37.4798 67.8961 41.7455 70.1762 46.3894 71.0999C51.0333 72.0237 55.8469 71.5496 60.2213 69.7376C64.5958 67.9256 68.3347 64.8572 70.9653 60.9203C73.5958 56.9834 74.9999 52.3548 74.9999 47.6199C74.9999 41.2706 72.4776 35.1814 67.988 30.6918C63.4984 26.2022 57.4092 23.6799 51.0599 23.6799ZM51.0599 61.6799C48.2714 61.6819 45.5451 60.8565 43.2261 59.3081C40.907 57.7597 39.0995 55.5581 38.0324 52.9819C36.9654 50.4057 36.6867 47.5709 37.2316 44.8362C37.7766 42.1015 39.1207 39.59 41.0939 37.6197C43.067 35.6494 45.5804 34.3088 48.3158 33.7677C51.0513 33.2267 53.8857 33.5094 56.4604 34.5801C59.0351 35.6509 61.2341 37.4615 62.7792 39.7827C64.3243 42.104 65.1458 44.8315 65.1399 47.6199C65.1399 49.4689 64.7757 51.2999 64.0681 53.0081C63.3605 54.7164 62.3234 56.2685 61.0159 57.576C59.7085 58.8834 58.1563 59.9206 56.4481 60.6282C54.7398 61.3357 52.9089 61.6999 51.0599 61.6999V61.6799Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.74 22.6299H99.4099V53.6299H107.74V22.6299Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8199 93.48V98.9C86.9899 107.9 96.4499 111.19 96.4499 111.19H52.1699C52.1699 111.19 61.9999 107.77 63.9199 98.38V94.55",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9399 84.02V9.54004H132.68",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M132.68 9.54004V84.02H15.9399",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9399 138.11L23.9999 118.84H108.54L117.6 138.11",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.69 123.87H27.56L20.98 138.11",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5899 123.87L27.3899 136.07",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.63 123.87L34.74 130.63",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6798 128.9H25.5498",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6199 133.94H22.9099",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6799 95.0901C96.9999 106.29 104.36 110.17 113.48 109.2C120.41 108.46 122.67 103.74 121.05 101.87C117.3 97.5401 111.75 109.16 119.34 114.87C125.34 119.51 135.57 110.72 137.75 121.56V130.64",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M127.13 131.17H149.11",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3398 64.25H122.97",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3398 69.28H112.6",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0599 22.1101V47.6201L42.1499 71.1401",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26.26 41.4099L51.5 48.0599",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M41.73 23.8899L51.06 48.0599",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6599 54.36V34.97H93.9899V54.36",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M113.16 54.3601V45.3501H121.49V54.3601",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerCharts);
export default __webpack_public_path__ + "static/media/computer_charts.cd7a8c699451f13ab2206446efba9bf6.svg";
export { ForwardRef as ReactComponent };